import React from "react";
import AsyncSelect from "react-select/async";
const index = ({setSegments}) => {

    const segments = [
			"0",
			"1",
			"2",
			"CR2.6",
			"CR2.9",
			"CR2.10",
			"CR2.4",
			"CR2.13",
			"CR2.1",
			"CR2.8",
			"CR2.2",
			"CR2.12",
			"CR2.3",
			"CR2.15",
			"CR2.11",
			"CR2.16",
			"CR2.5",
			"CR2.14",
			"CR2.7",
			"CR2.17",
			"22",
			"15",
			"19",
			"12",
			"18",
			"20",
			"21",
			"23",
			"13",
			"14",
			"16",
			"6",
			"7",
			"11",
			"8",
			"17",
			"10",
			"24",
			"5",
			"9",
			"4",
			"KN3.9",
			"KN3.13",
			"KN3.2",
			"KN3.10",
			"KN3.1",
			"KN3.8",
			"KN3.12",
			"KN3.6",
			"KN3.3",
			"KN3.7",
			"KN3.5",
			"KN3.11",
			"KN3.4",
			"Mackenzie Creek 04",
			"LAD1.8",
			"LADTrails6.1",
			"Section 5",
			"Section 3",
			"LAD1.3",
			"Section 8",
			"LADBarton8.1",
			"RIO1.12",
			"RIO1.5",
			"RIO1.13",
			"RIO1.14",
			"RIO1.2",
			"RIO1.3",
			"RIO1.4",
			"RIO1.1",
			"RIO1.10",
			"RIO1.11",
			"RIO1.8",
			"RIO1.9",
			"RIO1.6",
			"RIO1.7",
			"KS7.1",
			"KS7.7",
			"KS7.5",
			"KS7.3",
			"KS6.5",
			"KS6.9",
			"KS6.4",
			"KS7.6",
			"KS7.8",
			"KS6.8",
			"KS6.7",
			"KS6.6",
			"KS6.3",
			"KS6.1",
			"KS6.2",
			"KS7.4",
			"KS7.2",
		];

	return (
		<AsyncSelect
			isMulti
			cacheOptions
			defaultOptions={segments.map((segment) => ({
				label: segment,
				value: segment,
			}))}
			loadOptions={(inputValue, callback) => {
				// Simple filter for demonstration; replace with API call if needed
				const filtered = segments
					.filter((segment) =>
						segment.toLowerCase().includes(inputValue.toLowerCase()),
					)
					.map((segment) => ({
						label: segment,
						value: segment,
					}));
				callback(filtered);
			}}
			onChange={(selectedOptions) => {
				// selectedOptions is an array of { label, value }
				setSegments(
					selectedOptions ? selectedOptions.map((opt) => opt.value) : [],
				);
			}}
			classNamePrefix={'async_select'}
			placeholder="Select Segment(s)"
		/>
	);
};

export default index;
